import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import "../login/login.css";

const ForgetPassword = ({ loginFor = "CLIENT", onClose }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const slug = loginFor || params.get("loginfor");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpField, setOtpField] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobileno, setMobileNo] = useState("");

  const [provider, setProvider] = useState({
    userName: "",
    type: slug === "ADMIN" ? "ARN" : slug,
    source: "link",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (otpField) {
        // Submitting OTP
        const otpData = {
          OtpMobileNo: mobileno,
          mobileOtp: otp,
        };
        const response = await axios.post("https://redvisionweb.com/api/login/submit-forget-password", otpData);

        if (response.data.msgType === "success") {
          setError(`${response.data.msg}`);
        } else {
          setError(`${response.data.msg}`);
        }
      } else {
        // Request OTP
        const response = await axios.post("https://redvisionweb.com/api/login/forget-password", provider);

        if (response.data.msgType === "success") {
          setOtpField(true);
          setMobileNo(response.data.encryptedMobileNo);
          setError(
            `OTP sent to ******${response.data.mobileLastFourDigit} and email ${response.data.email}. Please enter it below.`
          );
        } else {
          setError(`${response.data.msg}`);
        }
      }
    } catch (err) {
      console.error("Error:", err);
      setError("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="modal-header">
        <h5 className="modal-title">Forgot Password</h5>
      </div>

      <div className="modal-body">
        <form onSubmit={handleSubmit} id="forgetPwdFormVerify">
          {!otpField ? (
            <>
              <label>Email or Username</label>
              <input
                type="text"
                value={provider.userName}
                onChange={(e) =>
                  setProvider({ ...provider, userName: e.target.value })
                }
                required
              />
            </>
          ) : (
            <>
              <label>OTP</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </>
          )}

          {error && <p className="error-msg">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Please wait..." : otpField ? "Verify OTP" : "Send OTP"}
          </button>
        </form>
      </div>
    </div>

  );
};

export default ForgetPassword;
